
import {throwError as observableThrowError, Subject } from 'rxjs';
import {take, delay, retryWhen, finalize, catchError, map} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import 'rxjs';

import { LoginService } from '../../login/shared/login.service';
import { environment } from './../../../environments/environment';


@Injectable()
export class BasicSettingsService {
    redirectUrl: string;
    private getAdminSubject = new Subject<any>();
    private refreshSubject = new Subject<any>();

    constructor(
        private http: HttpClient,
        private authenticate: LoginService,
    ) { }

    /* PUT METHODS START */
    dateChangeTime(data: any) {
        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        const options = { headers: headers };

        return this.http.put(environment.SERVER_URL + '/registration_setting_basic/update_date_change_time', data, options ).pipe(
                        map(this.extractData),
                        catchError(this.handleError),);
    }

    midnightWorkTimeChange(data: any) {
        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        const options = { headers: headers };

        return this.http.put(environment.SERVER_URL + '/registration_setting_basic/update_midnight_work_time', data, options ).pipe(
                        map(this.extractData),
                        catchError(this.handleError),);
    }

    renameFunction(data: any) {
        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        const options = { headers: headers };

        if (data.type === 'renameBranch') {
            return this.http.put(environment.SERVER_URL + '/registration_setting_basic/branch_office', data, options ).pipe(
                        map(this.extractData),
                        catchError(this.handleError),
                        finalize(() => {
                            this.refreshSubject.next();
                        }),);
        } else {
            return this.http.put(environment.SERVER_URL + '/registration_setting_basic/employment_category', data, options ).pipe(
                            map(this.extractData),
                            catchError(this.handleError),);
        }
    }

    deleteFunction(data: any) {
        if (data.type === 'deleteBranch') {
            return this.http.put(environment.SERVER_URL + '/registration_setting_basic/branch_office/delete', data).pipe(
                            map(this.extractData),
                            catchError(this.handleError),
                            finalize(() => {
                                this.refreshSubject.next();
                            }),);
        } else {
            return this.http.put(environment.SERVER_URL + '/registration_setting_basic/employment_category/delete', data).pipe(
                            map(this.extractData),
                            catchError(this.handleError),);
        }
    }

    deleteAdmin(staff_id) {
        return this.http.put(environment.SERVER_URL + '/administrator/delete', staff_id).pipe(
                        map(this.extractData),
                        catchError(this.handleError),
                        finalize(() => {
                            this.getAdminSubject.next();
                        }),);
    }

    // send time for interval
    sendTimeInterval(sendTime) {
        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        const options = { headers: headers };

        return this.http.put(environment.SERVER_URL + '/alert_mail_setting/send_time?_id=5b3d931533d9fd18889a139a&send_time='+sendTime, options).pipe(
                        map(this.extractData),
                        catchError(this.handleError),);
    }

    // toggle branches for interval
    toggleBranchOffices(data) {
        const headers = new HttpHeaders({ 'Authorization': this.authenticate.getToken(), 'Content-Type': 'application/json' });
        const options = { headers: headers };

        return this.http.put(environment.SERVER_URL + '/alert_mail_setting/alert_branch?_id='+data._id+'&alert_email='+data.alert_email+'&branch_name='+data.name, options).pipe(
                        map(this.extractData),
                        catchError(this.handleError),);
    }

    // saving the interval option
    updateInterval(data: any) {
        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        const options = { headers: headers };

        return this.http.put(environment.SERVER_URL + '/alert_mail_setting/send_email_sche', data, options).pipe(
                        map(this.extractData),
                        catchError(this.handleError),);
    }

    updateGroup(data: any) {
        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        const options = { headers: headers };

        return this.http.put(environment.SERVER_URL + '/group_setting/', data, options).pipe(
                        map(this.extractData),
                        catchError(this.handleError),
                        finalize(() => {
                            this.refreshSubject.next();
                        }),);
    }
    /* PUT METHODS END */

    /* DELETE METHODS START */
    deleteGroup(id: string) {
        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        const options = { headers: headers };

        return this.http.delete(environment.SERVER_URL + '/group_setting/?_id=' + id, options).pipe(
                        map(this.extractData),
                        catchError(this.handleError),
                        finalize(() => {
                            this.refreshSubject.next();
                        }),);
    }

    deleteCompanyHoliday(id: string) {
        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        const options = { headers: headers };

        return this.http.delete(environment.SERVER_URL + '/registration_setting_basic/company_holiday?id=' + id, options).pipe(
                        map(this.extractData),
                        catchError(this.handleError),
                        finalize(() => {
                            this.refreshSubject.next();
                        }),);
    }

    deleteWorkingDay(id: string) {
        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        const options = { headers: headers };

        return this.http.delete(environment.SERVER_URL + '/registration_setting_basic/attendance_day?id=' + id, options).pipe(
                        map(this.extractData),
                        catchError(this.handleError),
                        finalize(() => {
                            this.refreshSubject.next();
                        }),);
    }

    deleteWorkingHours(id: string) {
        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        const options = { headers: headers };

        return this.http.delete(environment.SERVER_URL + '/registration_setting_basic/change_working_hour?id=' + id, options).pipe(
                        map(this.extractData),
                        catchError(this.handleError),
                        finalize(() => {
                            this.refreshSubject.next();
                        }),);
    }

    /* DELETE METHODS END */


    /* GET METHODS START */

    // get all staffs for adding admin
    getAllStaffs(data: any) {
        data.token = this.authenticate.getToken();
        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        const options = { headers: headers };

        return this.http.get(environment.SERVER_URL + '/gms_staff/all?limit='+data.limit+'&page='+data.page+'&search_name='+data.search_name, options).pipe(
                        map(this.extractData),
                        catchError(this.handleError),);
    }

    // view for the whole page of basic registration settings
    getBasicTimeDetails() {
        const headers = new HttpHeaders({ 'Authorization': this.authenticate.getToken(), 'Content-Type': 'application/json' });
        const options = { headers: headers };

        return this.http.get(environment.SERVER_URL + '/registration_setting_basic/detail', options).pipe(
                        map(this.extractData),
                        catchError(this.handleError),);
    }

    getAlertSetDetails() {
        const headers = new HttpHeaders({ 'Authorization': this.authenticate.getToken(), 'Content-Type': 'application/json' });
        const options = { headers: headers };

        return this.http.get(environment.SERVER_URL + '/alert_mail_setting/detail', options).pipe(
                        map(this.extractData),
                        catchError(this.handleError),);
    }

    // view list of company holidays
    getCompanyHolidayList(data: any) {
        const headers = new HttpHeaders({ 'Authorization': this.authenticate.getToken(), 'Content-Type': 'application/json' });
        const options = { headers: headers };

        return this.http.get(environment.SERVER_URL + '/registration_setting_basic/company_holiday/all?limit='+data.limit+'&page='+data.page, options).pipe(
                        map(this.extractData),
                        catchError(this.handleError),);
    }

    // view list of working holidays
    getWorkingHolidayList(data: any) {
        const headers = new HttpHeaders({ 'Authorization': this.authenticate.getToken(), 'Content-Type': 'application/json' });
        const options = { headers: headers };

        return this.http.get(environment.SERVER_URL + '/registration_setting_basic/attendance_day/all?limit='+data.limit+'&page='+data.page, options).pipe(
                        map(this.extractData),
                        catchError(this.handleError),);
    }

    // view list of working hours
    getWorkingHoursList(data: any) {
        const headers = new HttpHeaders({ 'Authorization': this.authenticate.getToken(), 'Content-Type': 'application/json' });
        const options = { headers: headers };

        return this.http.get(environment.SERVER_URL + '/registration_setting_basic/change_working_hour/all?limit='+data.limit+'&page='+data.page, options).pipe(
                        map(this.extractData),
                        catchError(this.handleError),);
    }

    // branch dropdown
    getBranches() {
        const headers = new HttpHeaders({ 'Authorization': this.authenticate.getToken(), 'Content-Type': 'application/json' });
        const options = { headers: headers };

        return this.http.get(environment.SERVER_URL + '/registration_setting_basic/branch_office/all', options).pipe(
                        map(this.extractData),
                        catchError(this.handleError),);
    }

    // employment category dropdown
    getEmployments() {
        const headers = new HttpHeaders({ 'Authorization': this.authenticate.getToken(), 'Content-Type': 'application/json' });
        const options = { headers: headers };

        return this.http.get(environment.SERVER_URL + '/registration_setting_basic/employment_category/all', options).pipe(
                        map(this.extractData),
                        catchError(this.handleError),);
    }

    getTemplates() {
        const headers = new HttpHeaders({ 'Authorization': this.authenticate.getToken(), 'Content-Type': 'application/json' });
        const options = { headers: headers };

        return this.http.get(environment.SERVER_URL + '/registration_setting_basic/template', options).pipe(
            map(this.extractData),
            catchError(this.handleError),);
    }

    getAdminList() {
        const headers = new HttpHeaders({ 'Authorization': this.authenticate.getToken(), 'Content-Type': 'application/json' });
        const options = { headers: headers };

        return this.http.get(environment.SERVER_URL + '/administrator/all?limit=50&page=1', options).pipe(
                        map(this.extractData),
                        catchError(this.handleError),);
    }

    getGroupList() {
        const headers = new HttpHeaders({ 'Authorization': this.authenticate.getToken(), 'Content-Type': 'application/json' });
        const options = { headers: headers };

        return this.http.get(environment.SERVER_URL + '/group_setting/groups', options).pipe(
                        map(this.extractData),
                        catchError(this.handleError),);
    }

    getGroupLeaders(id: string) {
        const headers = new HttpHeaders({ 'Authorization': this.authenticate.getToken(), 'Content-Type': 'application/json' });
        const options = { headers: headers };

        return this.http.get(environment.SERVER_URL + '/group_setting/leaders?_id='+id, options).pipe(
                        map(this.extractData),
                        catchError(this.handleError),);
    }

    getGroupMembers(data: any) {
        const headers = new HttpHeaders({ 'Authorization': this.authenticate.getToken(), 'Content-Type': 'application/json' });
        const options = { headers: headers };

        return this.http.get(environment.SERVER_URL + '/group_setting/members?_id='+data._id+'&limit='+data.limit+'&page='+data.page, options).pipe(
                        map(this.extractData),
                        catchError(this.handleError),);
    }
    /* GET METHODS END */

    /* POST METHODS START */
    // adding or saving company holiday
    addCompanyHoliday(data: any) {
        const headers = new HttpHeaders({ 'Authorization': this.authenticate.getToken(), 'Content-Type': 'application/json' });
        const options = { headers: headers };

        return this.http.post(environment.SERVER_URL + '/registration_setting_basic/company_holiday', data, options).pipe(
                        map(this.extractData),
                        catchError(this.handleError),
                        retryWhen(errors => errors.pipe(delay(1000),take(2),)),
                        finalize(() => {
                            this.refreshSubject.next();
                        }),);
    }

    // adding or saving working holiday
    addWorkingHoliday(data: any) {
        const headers = new HttpHeaders({ 'Authorization': this.authenticate.getToken(), 'Content-Type': 'application/json' });
        const options = { headers: headers };

        return this.http.post(environment.SERVER_URL + '/registration_setting_basic/attendance_day', data, options).pipe(
                        map(this.extractData),
                        catchError(this.handleError),
                        retryWhen(errors => errors.pipe(delay(1000),take(2),)),
                        finalize(() => {
                            this.refreshSubject.next();
                        }),);
    }

    // adding or saving new employment
    addEmploymentCat(data: any) {
        const headers = new HttpHeaders({ 'Authorization': this.authenticate.getToken(), 'Content-Type': 'application/json' });
        const options = { headers: headers };

        return this.http.post(environment.SERVER_URL + '/registration_setting_basic/employment_category', data, options).pipe(
                        map(this.extractData),
                        retryWhen(errors => errors.pipe(delay(1000),take(2),)),
                        catchError(this.handleError),);
    }

    // adding or saving new branch
    addBranch(name: string) {
        let data = {
            name: name
        }

        const headers = new HttpHeaders({ 'Authorization': this.authenticate.getToken(), 'Content-Type': 'application/json' });
        const options = { headers: headers };

        return this.http.post(environment.SERVER_URL + '/registration_setting_basic/branch_office', data, options).pipe(
                        map(this.extractData),
                        catchError(this.handleError),
                        retryWhen(errors => errors.pipe(delay(1000),take(2),)),
                        finalize(() => {
                            this.refreshSubject.next();
                        }),);
    }

    // adding or saving working hours
    addWorkingHours(data: any) {
        const headers = new HttpHeaders({ 'Authorization': this.authenticate.getToken(), 'Content-Type': 'application/json' });
        const options = { headers: headers };

        return this.http.post(environment.SERVER_URL + '/registration_setting_basic/change_working_hour', data, options).pipe(
                        map(this.extractData),
                        catchError(this.handleError),
                        retryWhen(errors => errors.pipe(delay(1000),take(2),)),
                        finalize(() => {
                            this.refreshSubject.next();
                        }),);
    }

    createGroup(data: any) {
        const headers = new HttpHeaders({ 'Authorization': this.authenticate.getToken(), 'Content-Type': 'application/json' });
        const options = { headers: headers };

        return this.http.post(environment.SERVER_URL + '/group_setting', data, options).pipe(
                        map(this.extractData),
                        catchError(this.handleError),
                        retryWhen(errors => errors.pipe(delay(1000),take(2),)),
                        finalize(() => {
                            this.refreshSubject.next();
                        }),);
    }

    // add admin
    addAdmin(staffs: any) {
        let array = {
            data: staffs
        };
        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        const options = { headers: headers };

        return this.http.post(environment.SERVER_URL + '/administrator/', array, options).pipe(
                        map(this.extractData),
                        catchError(this.handleError),
                        retryWhen(errors => errors.pipe(delay(1000),take(2),)),
                        finalize(() => {
                            this.getAdminSubject.next();
                        }),);
    }
    /* POST METHODS START */

    /* SUBSCRIPTION METHODS START */
    onGetAdmin() {
        return this.getAdminSubject.asObservable();
    }

    onRefresh() {
        return this.refreshSubject.asObservable();
    }
    /* SUBSCRIPTION METHODS START */

    private extractData(res: any) {
        let body = res;
        return body.data || {};
    }

    private handleError (error: any) {
        let errMsg: string;
        if (error) {
        const body = error || '';
        const err = body.error || JSON.stringify(body);
        errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
        } else {
        errMsg = error.message ? error.message : error.toString();
        }
        console.error(errMsg);
        return observableThrowError(errMsg);
    }
}